import React from 'react';
import Accordion from '../../../../components/Accordion/Accordion';
import {
    actualAttributes as attributesTitle,
    AttributesT,
} from '../../../../utils/constants';
import { ComponentControl } from '../../../ComponentControl/ComponentControl';
import s from './ConfigPanel.module.scss';

const { AccordionItem } = Accordion;

interface ConfigPanelProps {
    isActive: boolean;
    hasLoaded: boolean;
    actualAttributes: any;
    actualPrice: number;
    onReviewBuild: () => void;
}

export const ConfigPanel: React.FC<ConfigPanelProps> = ({
    isActive,
    hasLoaded,
    actualAttributes,
    actualPrice,
    onReviewBuild,
}) => {
    const activeCategory: any = attributesTitle;

    return (
        <div className={`${s.config} ${isActive ? s.active : ''}`}>
            <div className={s.title__wrapper}>
                <div className={s.title}>Change Jeep appearance</div>
                <div className={s.subtitle}>
                    Choose parts that fit your Jeep perfectly
                </div>
            </div>

            {hasLoaded && actualAttributes && (
                <div className={s.content}>
                    <Accordion>
                        {Object.keys(actualAttributes).map((name: any) => {
                            const actualName: AttributesT = name;
                            const activeItem = actualAttributes[actualName].activeItem;

                            if (activeCategory[name]) {
                                return (
                                    <AccordionItem
                                        activeItem={activeItem}
                                        defaultItem={actualAttributes[actualName].defaultItem}
                                        cameraPosition={
                                            actualAttributes[actualName].cameraPosition
                                        }
                                        label={attributesTitle[actualName]}
                                        actualName={actualName}
                                        key={`accordion-${name}`}
                                    >
                                        <div className={`${s.product__block} ${s[actualName]}`}>
                                            <ComponentControl attr={name} />
                                        </div>
                                    </AccordionItem>
                                );
                            }
                        })}
                    </Accordion>
                </div>
            )}

            {hasLoaded && actualAttributes && (
                <div className={s.offer__wrapper}>
                    <div className={s.offer_info}>
                        <div className={s.offer_title}>
                            <span className={s.desktop}>Total Summary</span>
                            <span className={s.mobile}>Total</span>
                        </div>
                        <div className={s.offer_price}>${actualPrice}</div>
                    </div>
                    <div
                        className={`${s.offer_btn} ${actualPrice == 0 ? s.disable : ''}`}
                        onClick={onReviewBuild}
                    >
                        <span className={s.desktop}>Review your build</span>
                        <span className={s.mobile}>Review build</span>
                    </div>
                </div>
            )}
        </div>
    );
};
